var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simulator-box without-padding end-xs"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.loading},on:{"click":_vm.callAction}},[_vm._v("\n        "+_vm._s(_vm.loading ? 'Salvando...' : 'Concluir')+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cda40bb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FooterSimulador.vue
// module id = null
// module chunks = 